import React from 'react';
import { Share2, Clock, Target, Repeat, BarChart2, ChevronLeft, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function SocialAutomation() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <header className="bg-white shadow-sm">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-2 text-indigo-600 hover:text-indigo-700">
              <ChevronLeft className="w-5 h-5" />
              <span>Back to Home</span>
            </Link>
            <a 
              href="https://wa.me/60177751631"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-green-600 hover:text-green-700"
            >
              <MessageCircle className="w-5 h-5" />
              <span>Contact on WhatsApp</span>
            </a>
          </div>
        </nav>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center mb-16">
          <Share2 className="w-16 h-16 text-indigo-600 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Social Media Automation</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Streamline your social media presence with intelligent automation tools and templates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-2xl font-bold mb-6">Key Features</h2>
            <div className="space-y-4">
              <div className="flex items-start">
                <Clock className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Scheduled Posting</h3>
                  <p className="text-gray-600">Plan and schedule content across multiple platforms automatically.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Target className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Audience Targeting</h3>
                  <p className="text-gray-600">Reach the right audience at the right time with smart targeting.</p>
                </div>
              </div>
              <div className="flex items-start">
                <Repeat className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Content Recycling</h3>
                  <p className="text-gray-600">Intelligently repurpose and reuse successful content.</p>
                </div>
              </div>
              <div className="flex items-start">
                <BarChart2 className="w-6 h-6 text-indigo-600 mt-1 mr-3" />
                <div>
                  <h3 className="font-semibold mb-1">Performance Tracking</h3>
                  <p className="text-gray-600">Monitor engagement and optimize your social strategy.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&q=80"
              alt="Social Media Dashboard"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold mb-4">Supported Platforms</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Facebook & Instagram</li>
                <li>• Twitter/X</li>
                <li>• LinkedIn</li>
                <li>• TikTok</li>
                <li>• YouTube</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/#contact"
            className="inline-flex items-center bg-indigo-600 text-white px-8 py-3 rounded-lg hover:bg-indigo-700 transition"
          >
            Start Automating Your Social Media
          </Link>
        </div>
      </div>
    </div>
  );
}